const identity = (s: unknown) => s;
const handler: ProxyHandler<any> = {
  get: () => new Proxy(identity, handler),
  apply: (_t, _this, args) => args[0],
};
export default new Proxy(identity, handler);
